import type { HoverInfo } from '../../engine/ControlsEngine'

const TYPE_LABELS: Record<string, string> = {
  zone: 'Zone',
  occupant: 'Occupant',
  wall: 'Mur',
}

interface Tooltip3DProps {
  info: HoverInfo
}

export default function Tooltip3D({ info }: Tooltip3DProps) {
  const typeLabel = TYPE_LABELS[info.type] ?? info.type

  return (
    <div
      style={{
        position: 'fixed',
        left: info.x + 15,
        top: info.y + 15,
        background: 'rgba(0, 0, 0, 0.85)',
        color: '#fff',
        padding: '4px 10px',
        borderRadius: 4,
        fontSize: 12,
        pointerEvents: 'none',
        zIndex: 1000,
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      }}
    >
      <strong>{typeLabel}:</strong> {info.name}
      {info.detail && <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>{info.detail}</div>}
    </div>
  )
}
